import api from "../lib/axios";

const BASE = "/communication-forms";

export const getEventForms = (eventId) => api.get(`${BASE}/event/${eventId}`);

export const getFormDetails = (formId) => api.get(`${BASE}/details/${formId}`);

export const createForm = (eventId, data) => api.post(`${BASE}/event/${eventId}`, data);

export const updateForm = (formId, data) => api.put(`${BASE}/${formId}`, data);

export const deleteForm = (formId) => api.delete(`${BASE}/${formId}`);

export const getPublicForm = (slug, token) =>
  api.get(`${BASE}/public/${slug}`, { params: token ? { token } : {} });

export const submitPublicForm = (slug, data) => api.post(`${BASE}/public/${slug}/submit`, data, data instanceof FormData ? {
  headers: { "Content-Type": undefined },
  transformRequest: [(body) => body],
} : undefined);

export const sendPublicFormOtp = (slug, data) => api.post(`${BASE}/public/${slug}/send-otp`, data);

export const verifyPublicFormOtp = (slug, data) => api.post(`${BASE}/public/${slug}/verify-otp`, data);

export const getFormSubmissions = (formId) => api.get(`${BASE}/${formId}/submissions`);

export const getEventSubmissions = (eventId) => api.get(`${BASE}/event/${eventId}/submissions`);

export const deleteSubmission = (submissionId) => api.delete(`${BASE}/submissions/${submissionId}`);

export const updateSubmission = (submissionId, data) => api.put(`${BASE}/submissions/${submissionId}`, data);

export const getRegistrationCustomForms = (registrationId, submissionId) =>
  api.get(`${BASE}/registration/${registrationId}`, {
    params: submissionId ? { submission_id: submissionId } : {},
  });
